// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { unit } from 'mathjs'

import {
  castToFloat,
  roundToFixed,
} from 'helpers/reduxFormFunctions'

import {
  precisionFt,
  precisionM,
} from 'config/constants'

const convertBetweenMandFt = (value, toUnitType) => {
  // only allow numbers
  if (castToFloat(value) === null) {
    return null
  }

  // if toUnitType is 'ft' then the given value is 'm'
  const v = unit(value, toUnitType === 'SI' ? 'ft' : 'm')

  // value converted into toUnitType
  const c = v.toNumber(toUnitType === 'SI' ? 'm' : 'ft')

  // determine the degree of precision for the new value
  const p = toUnitType === 'SI' ? precisionM : precisionFt

  return roundToFixed(c, p)
}

export default convertBetweenMandFt
